import { render, staticRenderFns } from "./infektionsrisiko-graph.vue?vue&type=template&id=fd4a92ee&"
import script from "./infektionsrisiko-graph.vue?vue&type=script&lang=js&"
export * from "./infektionsrisiko-graph.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports